/**
 * Plugin check quyền người dùng
* Created by PVTHONG 27/03/2021
 */
import Permission from "./Permission.vue";
Permission.install = (Vue, options = {}) => {
    let MyComponent = Vue.extend({
        render: h => {
            return h(Permission,{
                props: {
                    options: options
                },
                ref: "Permission"
            })
        }
    })
    var component = new MyComponent().$mount()
    document.body.appendChild(component.$el)
    Vue.prototype.$Permission = component.$refs.Permission
}
export default Permission;